
















































import {Vue, Component, Prop, VModel} from 'vue-property-decorator';
import {v4 as uuidv4} from "uuid";

export type Icon = "xmark" | "arrow-left"

@Component({})
export default class RightSideBar extends Vue {
	@Prop({default: "padding: 0 20px"})
	private bodyStyle!: string

	@Prop({default: "padding: 0 20px; margin-bottom: 24px;"})
	private footerStyle!: string

	@Prop({default: function () {return uuidv4()}})
	private id!: string;

	@Prop()
	private title!: string

	@Prop({default: "xmark"})
	private closeIcon!: Icon

	@VModel({type: Boolean, default: false})
	private model!: boolean
}
